import ajax from '../../utils/ajax';

/**
 * @typedef {Object} TimeRemainingResponse
 * @property {number} millisecondsRemaining
 */

export default {
  /** @returns {Promise<TimeRemainingResponse>} */
  getTimeRemaining() {
    return ajax.get('/api/cart/timer');
  },

  transferSession() {
    return ajax.post('/api/session/transfer');
  },
};



// WEBPACK FOOTER //
// ./V7/cart/timer/CartTimerService.js